import { Hint, Label, Select, Tag } from 'components';
import { AiWorkflow } from 'gql/graphql';
import { GlossaryClipArt } from 'lib/svgs/ClipArts';
import { useTranslations } from 'next-intl';
import { FC, useMemo } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Option } from 'types/Option';
import { cn } from 'utils/cn';
import { assignGlossary, removeGlossary } from './_actions';

interface ISelectGlossaries {
  glossaries: { id: string; name: string }[];
  selectedGlossaries: string[];
  selectedAgent?: AiWorkflow;
}

const SelectGlossaries: FC<ISelectGlossaries> = ({
  glossaries = [],
  selectedGlossaries = [],
  selectedAgent
}) => {
  const t = useTranslations();
  const dispatch = useDispatch();
  const glossaryNames: Record<string, string> = glossaries.reduce(
    (acc, e) => ({ ...acc, [e.id]: e.name }),
    {}
  );

  const handlerOnChange = ({ value }: Option) => {
    if (value) dispatch(assignGlossary(value));
  };

  const selectedGlossariesWithAgent = useMemo(() => {
    if (selectedAgent) {
      const glossary = selectedAgent.glossary;

      if (glossary?.id) return [glossary.id];
    }

    return selectedGlossaries;
  }, [glossaries, selectedGlossaries, selectedAgent]);

  return (
    <>
      <Label>{t('ordering_form.assigned_glossary')}</Label>
      <Hint className="mb-4">{t('ordering_form.assigned_glossary_explanation')}</Hint>
      <Select
        options={glossaries.map((glossary) => ({ value: glossary.id, label: glossary.name }))}
        onChange={handlerOnChange}
        disabled={!!selectedAgent}
      />
      <div className="flex flex-wrap gap-4">
        {selectedGlossariesWithAgent.map((glossaryId) => (
          <Tag
            key={glossaryId}
            onRemove={() => dispatch(removeGlossary(glossaryId))}
            className={cn('relative rounded-full !bg-white')}
            classNameTypography="!text-primary-blue-100 ml-8"
            classNameRemove="ml-3"
            classNameCloseIcon="!text-primary-blue-100"
            startAdornment={
              <GlossaryClipArt className="absolute left-0 mr-4 h-[50px] w-[40px] scale-[0.35]" />
            }
          >
            {glossaryNames?.[glossaryId]}
          </Tag>
        ))}
      </div>
    </>
  );
};

const mapStateToProps = (state: any, ownProps: any) => {
  const {
    staticData: { glossaries },
    glossaries: selectedGlossaries
  } = state;
  const { selectedAgent } = ownProps;
  return {
    glossaries,
    selectedGlossaries,
    selectedAgent
  };
};

export default connect(mapStateToProps, { assignGlossary, removeGlossary })(SelectGlossaries);
